module.exports = __webpack_public_path__ + "img/pic2.6372250f.jpg";